import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BackButton } from '../../components/back-button/back-button';
import { ConfirmDialog } from '../../components/confirm-dialog/confirm-dialog';
import { InputComponent } from '../../components/input/input';
import { Loading } from '../../components/loading/loading';
import { Modal } from '../../components/modal/modal';
import { Table } from '../../components/table/table';
import { ColumnDef, flexRenderComponent } from '@tanstack/angular-table';
import {
  TableHeadSelectionComponent,
  TableRowSelectionComponent,
} from '../../components/select-column/select-column';
import { ConfirmDialogService } from '../../services/confirm-dialog-service';
import { ToastService } from '../../services/toast-service';
import { TMerchant } from '../merchants/merchants';
import { ClienteService } from '../../services/cliente-service';

@Component({
  selector: 'app-estabelecimentos',
  imports: [
    ConfirmDialog,
    Modal,
    InputComponent,
    ReactiveFormsModule,
    Table,
    BackButton,
    RouterLink,
    Loading,
  ],
  templateUrl: './estabelecimentos.html',
  styleUrl: './estabelecimentos.scss',
})
export class Estabelecimentos implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  loading = false;
  clientId = signal('');
  clientLabel = signal('');

  showModal = false;
  showConfirmDialog = false;
  message = '';

  data: any[] = [];

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private clienteService: ClienteService,
    private toast: ToastService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.clientId.set(params['id']);
      this.clientLabel.set(params['label']);
    });

    this.confirmDialogService.showDialog$.subscribe(({ message }) => {
      this.message = message;
      this.showConfirmDialog = true;
    });
  }

  ngOnInit(): void {
    this.getMerchants();
  }

  getMerchants() {
    this.loading = true;
    this.clienteService.getMerchants().subscribe((resp) => (this.data = resp));
    this.loading = false;
  }

  columns: ColumnDef<TMerchant>[] = [
    {
      id: 'select-col',
      header: () => flexRenderComponent(TableHeadSelectionComponent),
      cell: () => flexRenderComponent(TableRowSelectionComponent),
    },
    {
      accessorKey: 'merchantLabel',
      header: 'Merchant Label',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'merchantId',
      header: 'Merchant ID',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'cnpj',
      header: 'CNPJ',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'checkouts',
      header: 'Checkouts',
      cell: (info) => {
        const checkouts = (info.getValue() as Array<any>) ?? [];
        const checkoutsLength = checkouts.length == null ? 0 : checkouts.length;

        return `<a class="text-primary">( ${checkoutsLength} )</a>`;
      },
    },
    // {
    //   id: 'actions',
    //   enableHiding: false,
    //   cell: ({ row }) => {
    //     const merchant = row.original;
    //     return flexRenderComponent(TableButtons, {
    //       inputs: {
    //         title: '🗑️',
    //       },
    //       outputs: {
    //         // clickEvent: () => this.deletarMerchant(merchant),
    //       },
    //     });
    //   },
    // },
  ];

  merchantRegister = new FormGroup({
    label: new FormControl('', [Validators.required, Validators.minLength(3)]),
    CNPJ: new FormControl('', [Validators.required, Validators.minLength(11)]),
  });

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  // salvar() {
  //   if (this.merchantRegister.invalid)
  //     this.toast.show({
  //       message: 'Error',
  //       type: 'warn',
  //     });

  //   this.adminService
  //     .registerMerchant(
  //       this.merchantRegister.value.label!,
  //       this.clientId(),
  //       this.merchantRegister.value.CNPJ!
  //     )
  //     .subscribe({
  //       next: () => {
  //         this.toast.show({
  //           type: 'success',
  //           message: 'Cliente Adicionado',
  //         });
  //         this.getMerchants();
  //         this.closeModal();
  //       },
  //     });
  // }

  onConfirm() {
    this.confirmDialogService.confirm();
    this.showConfirmDialog = false;
  }

  onCancel() {
    this.confirmDialogService.cancel();
    this.showConfirmDialog = false;
  }

  // deletarMerchant(merchant: TMerchant) {
  //   this.confirmDialogService
  //     .requestConfirmation(`Deseja deletar [${merchant.merchantLabel}]?`)
  //     .subscribe((confirmed) => {
  //       if (confirmed) {
  //         this.adminService.deleteMerchant(this.clientId(), merchant.merchantId).subscribe(() => {
  //           this.toast.show({
  //             message: 'Cliente deletado com sucesso',
  //             type: 'info',
  //           });

  //           this.getMerchants();
  //         });
  //       } else {
  //         console.log('Ação cancelada');
  //       }
  //     });
  // }

  get formControls() {
    return Object.keys(this.merchantRegister.controls);
  }
}
